import api from 'api'

type PolicyWindow = {
  cutoffTimeHours: number
  chargePercentage?: number | null
  chargeMinutes?: number | null
}

export type CancellationPolicy = {
  id: number
  startsAt: string
  isDefault: boolean
  policyWindows: PolicyWindow[]
}

export type MinPayPolicy = {
  id: number
  startsAt: string
  minPayLengthInMinutes: number
  endsAt?: string | null
}

export type CompanyMember = {
  id: number
  name: string
  email: string
  companyRoleDescription: string
}

export type CompanyMemberPending = {
  email: string
  companyRoleDescription: string
  inviteLink: string
  inviteId: number
}

export type CompanyDayforceInfo = {
  clientId: string
  agencyId: string
  agencyName: string
  organizationId: string
  organizationName: string | null
  neverExpireRsw: boolean
}

type CompanyPosition = {
  id: number
  name: string
}

type CompanyGroup = {
  id: number
  name: string
}

type SalesOrAccountOwner = {
  id: number
  name: string
}

export type CompanyInvoiceConfig = {
  companyId?: number | null
  companyGroupId?: number | null
  breakdownLevels: string[]
  customWeek?: {
    weekStartDay: string
    timezone: string
  } | null
}

export type CompanyDetail = {
  id: number
  name: string
  createdAt: string
  type: '1099' | 'w2'
  requiresEverify: boolean
  logoUrl?: string
  dayforce?: CompanyDayforceInfo
  members: (CompanyMember | CompanyMemberPending)[]
  positions: CompanyPosition[]
  companyGroup?: CompanyGroup
  activeCancellationPolicyWindows?: unknown[]
  activeCancellationPolicy: CancellationPolicy
  upcomingCancellationPolicies: CancellationPolicy[]
  activeMinPayPolicy?: MinPayPolicy | null
  upcomingMinPayPolicies: MinPayPolicy[]
  salesOwner?: SalesOrAccountOwner
  accountOwner?: SalesOrAccountOwner
  terminalTierThresholdHours: number
  terminalTierThresholdDirection: 'after_shift_create' | 'before_shift_start'
  paymentMethod?: 'invoice' | 'card' | 'bank_account' | (string & object)
  invoiceDueDays?: number
  invoiceConfig?: CompanyInvoiceConfig
  shiftLeadChargePolicy?: string
  chargeCushionWorkers: boolean
  pastShiftCreationAllowed: boolean
  takeRate1099?: number
  bonusTakeRate?: number
  tipTakeRate?: number
  w2RegularTakeRate?: number
  w2DoubleTakeRate?: number
  w2OvertimeTakeRate?: number
}

export const getCompanyDetail = async (
  companyId: number
): Promise<CompanyDetail> => {
  const response = await api.get(`/admin/company/${companyId}`)
  return response.data
}
